import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import login from "./modules/LoginModule";
import featureToggling from "./modules/FeatureTogglingModule";
import navigationChecks from "./modules/NavigationModule";
import alternativeResults from "./modules/AlternativeResults";
import device from "./modules/DeviceModule";

Vue.use(Vuex);

const store = new Vuex.Store({
	state,
	actions,
	mutations,
	getters,
	modules: {
		login,
		features: featureToggling,
		navigationChecks,
		alternativeResults,
		device,
	},
});

export default store;
